import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";
import { withRouter, Prompt } from "react-router";
import classnames from "classnames";
import { toast } from "react-toastify";

import * as actions from "../../../../store/actions";
import {
  REMOVE_VALIDATIONS,
  VALIDATE_PERSONALINFO,
} from "../../../../store/actions/actionTypes";
import { getUserData } from "../../../../utils/localStorage";
import { getOnboardingPath } from "../../../../constants";
import constants from "../../../../constants";

import Button from "../../../../components/formElements/button/Button";
import TextInput from "../../../../components/formElements/input/TextInput";
import RadioButton from "../../../../components/formElements/radio-button/RadioButton";
import SelectInput from "../../../../components/formElements/selectInput/SelectInput";
import TextArea from "../../../../components/formElements/textArea/TextArea";
import Row from "../../../../components/uiElements/grid/Row";
import Card from "../../../../layout/Onboarding/Card";
import OnboardingIcon from "../../../../components/uiElements/icons/onboardingIcons/OnboardingIcon";

import DateTimePicker from "../../../../components/formElements/datepicker/DateTimePicker";

const StepOne = ({
  personalInfo,
  setPersonalInfo,
  history,
  form,
  validateData,
  getSpecialityList,
  getLanguageList,
  getEducationalList,
  saveDoctorDetails,
  redirectedPath,
  updateDoctorDetail,
  removeValidations,
  getDoctorAppTheme,
}) => {
  const skillStyles = {
    multiValue: styles => {
      return {
        ...styles,
        background: "var(--pallet-color)",
      };
    },
    multiValueLabel: styles => ({
      ...styles,
      color: "white",
    }),
    multiValueRemove: styles => ({
      ...styles,
      color: "white",
      ":hover": {
        backgroundColor: "transparent",
      },
    }),
    placeholder: styles => ({
      ...styles,
      color: "#bbc1d0",
    }),
    dropdownIndicator: styles => ({
      ...styles,
      paddingRight: 25,
      display: "inline",
    }),
  };

  const myRef = useRef();

  useEffect(() => {
    if (form && form.personalInfoValid) {
      if (
        redirectedPath ||
        (personalInfo.dataLoaded && personalInfo.dataChanged)
      ) {
        updateDoctorDetail(() => {
          personalInfo.dataLoaded &&
            personalInfo.dataChanged &&
            history.push(getOnboardingPath("/step2"));
        });
      } else {
        saveDoctorDetails(() => {
          history.push(getOnboardingPath("/step2"));
        });
      }
    } else if (form.personalInfoValid === false) {
      myRef?.current?.querySelector(":invalid")?.scrollIntoView({
        behavior: "smooth",
      });
    }

    form.personalInfoValid = false;
    toast.error(form.gender, {
      position: constants.TOAST_POSITION,
    });
    toast.error(form.date_of_birth, {
      position: constants.TOAST_POSITION,
    });
    // eslint-disable-next-line
  }, [form]);

  useEffect(() => {
    if (
      personalInfo.specialitiesOptions.length === 0 &&
      personalInfo.languagesOptions.length === 0 &&
      personalInfo.educationalOptions.length === 0
    ) {
      getSpecialityList();
      getLanguageList();
      getEducationalList(
        () => redirectedPath && setPersonalInfo({ dataChanged: false })
      );
    }

    const userData = getUserData();

    if (!personalInfo.firstName && !personalInfo.lastName) {
      setPersonalInfo({
        firstName: userData.firstName,
      });
      setPersonalInfo({
        lastName: userData.lastName,
      });
    }
    redirectedPath && setPersonalInfo({ dataChanged: false });
    redirectedPath && setPersonalInfo(personalInfo.copy);
    removeValidations();

    // eslint-disable-next-line
  }, []);

  const defaultMaxDateForDOB = () => {
    let date = new Date();
    date.setFullYear(date.getFullYear() - 18);
    return new Date(date);
  };

  return (
    <>
      {redirectedPath && (
        <Prompt
          when={personalInfo.dataChanged}
          message="You have unsaved changes, are you sure you want to leave?"
        />
      )}
      <div
        ref={myRef}
        className={classnames(
          "onboarding-container"
          // personalInfo.dataLoaded && !redirectedPath && "disable"
        )}
      >
        <p className="onboarding-header">
          Personal
          <br /> Details
        </p>
        <Row>
          <Card>
            <TextInput
              id="firstName"
              error={form.firstName}
              maxLength={15}
              type="text"
              label="First Name"
              value={personalInfo.firstName}
              onChange={val => setPersonalInfo({ firstName: val })}
            />
            <TextInput
              id="lastName"
              error={form.lastName}
              maxLength={15}
              type="text"
              label="Last Name"
              value={personalInfo.lastName}
              onChange={val => setPersonalInfo({ lastName: val })}
            />
            <div className="mt-n4 ml-n3">
              <RadioButton
                containerClassName="d-inline"
                label="Male"
                value="MALE"
                name="gender"
                checked={personalInfo.gender === "MALE"}
                onChange={val => setPersonalInfo({ gender: val })}
              />
              <RadioButton
                containerClassName=" d-inline"
                label="Female"
                value="FEMALE"
                name="gender"
                checked={personalInfo.gender === "FEMALE"}
                onChange={val => setPersonalInfo({ gender: val })}
              />
            </div>

            <div className="my-4">
              <DateTimePicker
                MaxDate={ defaultMaxDateForDOB() }
                mode="date"
                type="personalPatientInfo"
                placeholder="Date of Birth"
                value={personalInfo.date_of_birth}
                customInput={true}
                onChange={val => setPersonalInfo({ date_of_birth: val })}
              />
            </div>

            <div className="mt-3 mb-5">
              <SelectInput
                error={form.specialities}
                hideSelectedOptions={true}
                isClearable={false}
                isMulti
                styles={skillStyles}
                isCreateble
                isSearchable
                options={personalInfo.specialitiesOptions}
                placeholder="Specialities"
                value={personalInfo.specialities}
                onChange={val => setPersonalInfo({ specialities: val })}
              />
            </div>
            <TextInput
              error={form.yearsOfExperience}
              type="number"
              maxLength={3}
              label="Years of Experience"
              value={personalInfo.yearsOfExperience}
              onChange={val => setPersonalInfo({ yearsOfExperience: val })}
            />
            <TextArea
              error={form.aboutMe}
              label="About me"
              maxLength={500}
              value={personalInfo.aboutMe}
              onChange={val => setPersonalInfo({ aboutMe: val })}
            />
            <div className="mt-n4 mb-5">
              <SelectInput
                error={form.languages}
                hideSelectedOptions={true}
                isClearable={false}
                isMulti
                styles={skillStyles}
                isCreateble
                isSearchable
                options={personalInfo.languagesOptions}
                placeholder="Languages"
                value={personalInfo.languages}
                onChange={val => setPersonalInfo({ languages: val })}
              />
            </div>
          </Card>
          <Card title="Educational Details">
            <div className="mt-n4 mb-5">
              <SelectInput
                error={form.degree}
                menuPlacement="top"
                options={personalInfo.educationalOptions}
                placeholder="Degree"
                styles={skillStyles}
                value={personalInfo.degree}
                onChange={val => setPersonalInfo({ degree: val })}
              />
            </div>
          </Card>
          {!redirectedPath ? (
            <Button
              type="secondary"
              indicatorButton
              className={classnames(
                "float-right next-button",
                personalInfo.dataLoaded && "enable"
              )}
              onClick={() =>
                personalInfo.dataLoaded && !personalInfo.dataChanged
                  ? history.push(getOnboardingPath("/step2"))
                  : validateData(personalInfo)
              }
              label={<OnboardingIcon type="nextButton" />}
            />
          ) : (
            <Button
              type="info"
              disabled={!personalInfo.dataChanged && true}
              className={classnames("w-75 mx-auto mb-4")}
              onClick={() => validateData(personalInfo)}
              label={"Save Changes"}
            />
          )}
        </Row>
      </div>
    </>
  );
};

const mapStoreToProps = ({ onboarding, validation, auth }) => ({
  personalInfo: onboarding.personalInfo,
  form: validation.data,
  redirectedPath: auth.redirectToOnboardingPath,
});

const mapDispatchToProps = dispatch => ({
  setPersonalInfo: updatedData =>
    dispatch(actions.setPersonalInfo(updatedData)),
  validateData: personalInfoData =>
    dispatch(actions.validateData(VALIDATE_PERSONALINFO, personalInfoData)),
  removeValidations: () =>
    dispatch(actions.validateData(REMOVE_VALIDATIONS, {})),
  getSpecialityList: () => dispatch(actions.getSpecialityList()),
  getLanguageList: () => dispatch(actions.getLanguageList()),
  getEducationalList: cb => dispatch(actions.getEducationalList(cb)),
  getDoctorAppTheme: cb => dispatch(actions.getDoctorAppTheme()),
  saveDoctorDetails: cb => dispatch(actions.saveDoctorDetails(cb)),
  updateDoctorDetail: cb => dispatch(actions.updateDoctorDetail(cb)),
});

export default withRouter(
  connect(mapStoreToProps, mapDispatchToProps)(StepOne)
);
